import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { ExternalLink } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * A link to form.dev, drawn as a small outlined button (docs/specs/vitrine.md
 * section 7, maquette `vitrine.html`: « Ouvrir sur form.dev »).
 *
 * An `<a>` and not a `Link` of the router: the target is ANOTHER SERVER, so the
 * router has nothing to resolve, and it opens in a tab of its own - an operator
 * who goes to the atelier to change something comes back to the page they
 * were reading. `rel="noreferrer"` because the atelier has no business learning
 * which address of the vitrine sent the visitor.
 *
 * Its colours are the ones of the banner it sits in: the border and the text
 * take the ciel ink the banner paints, over a white ground, so the control
 * reads as a button inside a tinted box.
 */

export interface AtelierLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
}

export function AtelierLink({ href, children, className, ...rest }: AtelierLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={cn(
        buttonVariants({ variant: 'outline', size: 'sm' }),
        'border-bleu-ciel-deep text-bleu-ciel-deep no-underline hover:bg-bleu-ciel-tint hover:text-bleu-ciel-deep',
        className,
      )}
      {...rest}
    >
      {children}
      <ExternalLink aria-hidden="true" className="size-4" />
    </a>
  );
}
